

<div class="card mb-4">
    <div class="card-body">
        <div class="row mb-2 mt-2">
            <div class="col-md-2 mt-3 offset-md-10">
        <button class="btn btn-outline-primary btn-sm"><a routerLinkActive="router-link-active" routerLink="/glueingProdForm">
            <span class="nav-menu-item-title"> 
                <i class="feather icon-tag ng-star-inserted"></i>Glueing </span>
        </a></button>
        </div>
        </div>
  
      <div class="row">
        <!-- Grid column -->
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h4 class="mb-4 fw-bolder align-items-center"> Glueing Records </h4>
            </div>
        
          </div>



           <!-- Filter Section -->
     <div class="row mb-4">
        <!-- Search by Operator -->
        <!-- <div class="col-md-3">
          <div class="form-group">
            <label for="searchOperator">Search by Operator</label>
            <input
              type="text"
              id="searchOperator"
              class="form-control"
              [(ngModel)]="searchOperator"
              (ngModelChange)="filterTable()"
              placeholder="Search Operator"
            />
          </div>
        </div> -->
        <div class="col-md-2">
  <div class="form-group">
    <label for="searchOperator">Search by Operator</label>
    <select
      id="searchOperator"
      class="form-control"
      [(ngModel)]="searchOperator"
      (ngModelChange)="filterTable()"
    >
      <option value="" disabled>Select an Operator</option>
      <option value="SURESH BHOJANAE">SURESH BHOJANAE</option>
      <option value="MANGESH SHELAR">MANGESH SHELAR</option>
      <option value="VAHID KHOT">VAHID KHOT</option>
      <option value="VIGNESH DESAI">VIGNESH DESAI</option>
      <option value="RAGHAVENDRA SAFI">RAGHAVENDRA SAFI</option>
      <option value="GAJENDRA PRATAP SINGH">GAJENDRA PRATAP SINGH</option>
      <option value="PRASHANT DAS">PRASHANT DAS</option>
      <option value="AJAY KUMAR">AJAY KUMAR</option>
      <option value="NIRANJAN YADAV">NIRANJAN YADAV</option>
      <option value="MAYUR CHAVAN">MAYUR CHAVAN</option>
      <option value="SURAJ SINGH CHAUHAN">SURAJ SINGH CHAUHAN</option>
      <option value="VIKRAM SINGH">VIKRAM SINGH</option>
      <option value="SHIVAM BHARDWAJ">SHIVAM BHARDWAJ</option>
      <option value="SHIVAM KUMAR">SHIVAM KUMAR</option>
      <option value="SACHIN KOLHE">SACHIN KOLHE</option>
      <option value="PRIYANSHU VERMA">PRIYANSHU VERMA</option>
      <option value="RANJAN SETHI">RANJAN SETHI</option>
      <option value="SURENDRA PAL">SURENDRA PAL</option>
      <option value="DHEERAJ">DHEERAJ</option>
      <option value="DELE- OLANREWAJU SAHEED">DELE- OLANREWAJU SAHEED</option>
      <option value="WASIU KAYODE BUSARI">WASIU KAYODE BUSARI</option>
      <option value="IBRAHIM OLADIMEJI">IBRAHIM OLADIMEJI</option>
      <option value="FOLAYINKA KILANI">FOLAYINKA KILANI</option>
      <option value="ABIODUN OLALEKAN ADEBIJI">ABIODUN OLALEKAN ADEBIJI</option>
      <option value="DANIEL OLUWADAMILARE">DANIEL OLUWADAMILARE</option>
      <option value="DEEPAK SHARMA">DEEPAK SHARMA</option>
      <option value="SANJAY CHAURASIYA">SANJAY CHAURASIYA</option>
      <option value="VIVEK KUMAR">VIVEK KUMAR</option>
      <option value="ARUN">ARUN</option>
      <option value="SOLOMAN">SOLOMAN</option>
      <option value="ENOCH">ENOCH</option>
      <option value="FRANCISCA">FRANCISCA</option>
      <option value="PATIENCE">PATIENCE</option>
      <option value="SAMUEL">SAMUEL</option>
      <option value="BRUCE">BRUCE</option>
      <option value="MARY">MARY</option>
      <option value="ROMEO">ROMEO</option>
      <option value="REUBEN">REUBEN</option>
      <option value="MAWUENA">MAWUENA</option>

      <!-- Newly added names -->
    <option value="JOEL">JOEL</option>
    <option value="MARK">MARK</option>
    <option value="DANIEL">DANIEL</option>
    <option value="ABBEY">ABBEY</option>
    <option value="KING">KING</option>
    <option value="FOSTER">FOSTER</option>
    <option value="JUDITH">JUDITH</option>
    <option value="OLIVIA">OLIVIA</option>
    <option value="BEATRICE">BEATRICE</option>
    <option value="VERA">VERA</option>
    <option value="VIKAS">VIKAS</option>
    <option value="ARUN">ARUN</option>
    <option value="AKIN">AKIN</option>
    <option value="SAFIATU">SAFIATU</option>
    <option value="PATRICIA">PATRICIA</option>
    <option value="BERNICE">BERNICE</option>

        <option value="STEVEN">STEVEN</option>
    <option value="OSMAN">OSMAN</option>
    <option value="EMMANUEL">EMMANUEL</option>
    <option value="MAJEED">MAJEED</option>
    <option value="RAM KISHAN">RAM KISHAN</option>
    <option value="BASIT">BASIT</option>
    <option value="SAMAD">SAMAD</option>
    <option value="HARSHA">HARSHA</option>

   <option value="VISHAL">VISHAL</option>
   <option value="ADEMOLA">ADEMOLA</option>
   <option value="ASHISH">ASHISH</option>
   <option value="DAVID AWONARO">DAVID AWONARO</option>
     <option value="DHANJAY">DHANJAY</option>
      <option value="VINAY">VINAY</option>
       <option value="VINAY KUMAR SINGH">VINAY KUMAR SINGH</option>
    </select>
  </div>
</div>
  
        <!-- Search by Shift -->
        <div class="col-md-1">
          <div class="form-group">
            <label for="searchShift">Shift</label>
            <!-- <input
              type="text"
              id="searchShift"
              class="form-control"
              [(ngModel)]="searchShift"
              (ngModelChange)="filterTable()"
              placeholder="Search Shift"
            /> -->
            <input
  type="text"
  class="form-control"
  list="shiftList"
  [(ngModel)]="searchShift"
  (input)="filterTable()"
  placeholder="Search Shift">

<datalist id="shiftList">
  <option
    *ngFor="let shift of shiftNames"
    [value]="shift">
  </option>
</datalist>
          </div>
        </div>
  
        <!-- Search by Machine -->
        <div class="col-md-1">
          <div class="form-group">
            <label for="searchMachine">Machine</label>
            <!-- <input
              type="text"
              id="searchMachine"
              class="form-control"
              [(ngModel)]="searchMachine"
              (ngModelChange)="filterTable()"
              placeholder="Search Machine"
            /> -->
            <input
  type="text"
  class="form-control"
  list="machineList"
  [(ngModel)]="searchMachine"
  (input)="filterTable()"
  placeholder="Search Machine">

<datalist id="machineList">
  <option
    *ngFor="let machine of machineNames"
    [value]="machine">
  </option>
</datalist>
          </div>
        </div>
  
        <!-- Search by Client -->
        <div class="col-md-2">
          <div class="form-group">
            <label for="searchClient">Search by Client</label>
            <!-- <input
              type="text"
              id="searchClient"
              class="form-control"
              [(ngModel)]="searchClient"
              (ngModelChange)="filterTable()"
              placeholder="Search Client"
            /> -->
            <input
  type="text"
  class="form-control"
  list="clientList"
  [(ngModel)]="searchClient"
  (input)="filterTable()"
   placeholder="Search Client">

<datalist id="clientList">
  <option
    *ngFor="let client of clientNames"
    [value]="client">
  </option>
</datalist>
          </div>
        </div>



         <!-- Search by Job Name -->
    
        <div class="col-md-2">
          <div class="form-group">
            <label for="searchJobName">Search by Job Name</label>
            <!-- <input
              type="text"
              id="searchJobName"
              class="form-control"
              [(ngModel)]="searchJobName"
              (ngModelChange)="filterTable()"
              placeholder="Search Job Name"
            /> -->
            <input
  type="text"
  class="form-control"
  list="jobList"
  [(ngModel)]="searchJobName"
  (input)="filterTable()"
  placeholder="Search Job Name">

<datalist id="jobList">
  <option
    *ngFor="let job of jobNames"
    [value]="job">
  </option>
</datalist>
          </div>
        </div>



        <!-- ticket no -->
         <div class="col-md-2">
          <div class="form-group">
            <label for="searchTicket">Search by Ticket No</label>
            <!-- <input
              type="text"
              id="searchTicket"
              class="form-control"
              [(ngModel)]="searchTicket"
              (ngModelChange)="filterTable()"
              placeholder="Search Ticket"
            /> -->
            <input
  type="text"
  class="form-control"
  list="ticketList"
  [(ngModel)]="searchTicket"
  (input)="filterTable()"
  placeholder="Search Ticket">

<datalist id="ticketList">
  <option
    *ngFor="let ticket of ticketNumbers"
    [value]="ticket">
  </option>
</datalist>
          </div>
        </div>
        <!--  -->

        <div class="col-md-2">
  <div class="form-group">
    <label>Search by Ref No</label>

    <input
      type="text"
      class="form-control"
      list="refList"
      [(ngModel)]="searchRefNo"
      (input)="filterTable()"
      placeholder="Search Ref No">

    <datalist id="refList">
      <option
        *ngFor="let ref of refNumbers"
        [value]="ref">
      </option>
    </datalist>

  </div>
</div>
      </div>
  
     

  <!-- <div class="row mb-4">
 <div class="col-md-3"></div>
 </div> -->
 <div class="row mb-4">
  
        <!-- Search by From Date -->
  <!-- Filter by From Date -->
  <div class="col-md-3">
    <div class="form-group">
      <label for="searchFromDate">Search From Date</label>
      <input
        type="date"
        id="searchFromDate"
        class="form-control"
        [(ngModel)]="searchFromDate"
        (input)="filterTable()"
      />
    </div>
  </div>

  <!-- Filter by To Date -->
  <div class="col-md-3">
    <div class="form-group">
      <label for="searchToDate">Search To Date</label>
      <input
        type="date"
        id="searchToDate"
        class="form-control"
        [(ngModel)]="searchToDate"
        (input)="filterTable()"
      />
    </div>
  </div>

  <div class="col-md-2 mt-4"> 
  <button class="btn btn-outline-primary" type="button" (click)="clearFilters()" style="color:rgb(255, 0, 0); border:1px solid ">Clear Filters</button>
  </div>

  <div class="col-md-3 mt-4">
    <button class="btn btn-outline-success" (click)="exportToExcel()">
      <i class="feather icon-download"></i> Export to Excel
    </button>
  </div>

  <!-- uncomment below code for enabling print option -->
  <div class="col-md-3">
    <button type="button" class="btn btn-outline-primary mt-2" (click)="printGlueingData()">
      <span class="nav-menu-item-title">
        <i class="feather icon-tag"></i> Print
      </span>
    </button>
    
  </div>
      </div>
  
          

        
         
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <div class="table-responsive" style="max-height: 1000px; overflow-y: auto;">
       <!-- Display Temp Glueing Data in a Table -->
<!-- Pagination Controls -->
<div *ngIf="totalPages > 1">
    <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage <= 1">Previous</button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages">Next</button>
  </div>
  
  <!-- Table with Paginated Data -->
  <table  id="glueingPrintTable" *ngIf="paginatedTempGlueingData && paginatedTempGlueingData.length > 0" class="table table-bordered red-border text-center">
    <thead>
        <tr>
          <th>Ticket No</th>
          <th>Job Name</th>
          <th>Date</th>
          <th>Ref No</th>
          <th>PO Number</th>
          <th>Client Name</th>
          <th>Operator</th>
          <th>Shift</th>
          <th>Machine</th>

          <th>JCO</th>
        
          <th>Input</th>
          <th>Output</th>
          <th>Material </th>
        
          <!-- <th>Material 2</th> -->
          <th>Total Wastage</th>

            <th>No. of rolls</th>
              <th>Glue Supplier</th>
                <th>Total pcs</th>
                  <th>Pcs/kg</th>
        
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of paginatedTempGlueingData">
          <td>{{ entry.ticketNo }}</td>
          <td>{{ entry.jobName }}</td>
          <td>{{ formatDateForDisplay(entry.date) }}</td> <!-- Format date here -->
          <td>{{ entry.refNo }}</td>
          <td>{{ entry.poNumber }}</td>
          <td>{{ entry.clientName }}</td>
          <td>{{ entry.operator }}</td>
          <td>{{ entry.shift }}</td>
          <td>{{ entry.machine }}</td>

             <td>{{ entry.jco }}</td>
        
          <td>{{ entry.input }}</td>
          <td>{{ entry.output }}</td>
          <td>{{ entry.mat }}</td>
          <!-- <td>{{ entry.materialLam }}</td> -->
         
      
          <td>{{ entry.extra }}</td>
          <td>{{ entry.rollcount }}</td>
          <td>{{ entry.glueSupplier }}</td>
          <td>{{ entry.tpcs }}</td>
          <td>{{ entry.pckg }}</td>
         
          <td>{{ entry.remarks }}</td>
          
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="10" style="text-align: right; font-weight: bold;">Total:</td>
          <td><strong>{{ getTotal('input') | number: '1.2-2' }}</strong></td>
          <td><strong>{{ getTotal('output') | number: '1.2-2' }}</strong></td>
          
          <td></td>
          <!-- <td></td> -->
        
          <td><strong>{{ getTotal('extra') | number: '1.2-2' }}</strong></td>

          <td><strong>{{ getTotal('rollcount') | number: '1.2-2' }}</strong></td>
          <td></td>
          <td><strong>{{ getTotal('tpcs') | number: '1.2-2' }}</strong></td>
          <td><strong>{{ getTotal('pckg') | number: '1.2-2' }}</strong></td>
        
          <td><strong>{{ getTotal('remarks') | number: '1.2-2' }}</strong></td> <!-- Only if 'remarks' is numeric, otherwise remove this column -->
        </tr>
      </tfoot>
      
      
  </table>
  
  <!-- No data message -->
  <div *ngIf="paginatedTempGlueingData.length === 0">
    <p>No temporary production data available.</p>
  </div>
  
  
  <!-- If no data is available -->
  <div *ngIf="tempGlueingData.length === 0">
    <p>No temporary production data available.</p>
  </div>
  
      </div>

    <!-- Pagination Controls -->

   


    <div class="pagination-controls">
      <button
        class="btn btn-secondary"
        [disabled]="currentPage === 1"
        (click)="goToPage(currentPage - 1)"
      >
        <!-- Previous -->
        <i _ngcontent-guw-c91="" class="feather icon-chevrons-left"></i>
      </button>
     
      <!-- page info page 1 of 2 -->
      <!-- <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span> -->
       <!-- for only current page -->
       <span class="currentpage">{{ currentPage }}</span>

      <button
        class="btn btn-secondary"
        [disabled]="currentPage === totalPages"
        (click)="goToPage(currentPage + 1)"
      >
      <i _ngcontent-guw-c91="" class="feather icon-chevrons-right"></i>
      </button>
    </div>
     
      
    </div>
  </div>






  






  